/*
 * Daily Health & Beauty
 * Shared Storefront API and Customer Account API configuration
 *
 * This file is loaded globally from theme.liquid with:
 *
 *   {{ 'headless-api-config.js' | asset_url | script_tag }}
 *
 * Because it is loaded globally, Vendor Stories, Support, and other
 * storefront features can read the shared configuration from window.DHBSF.
 *
 * IMPORTANT:
 * - Keep the existing Storefront API property names, url and token, unchanged.
 * - The Storefront API token is a public storefront token.
 * - Do not place an Admin API token, client secret, or private credential here.
 * - Customer-specific access tokens are created after sign-in and must not be
 *   hardcoded in this file.
 */

window.DHBSF = {
  /*
   * Storefront API
   *
   * Existing pages and Vendor Stories use these properties. Do not rename,
   * remove, or change them without testing every Storefront API feature.
   */
  url: 'https://dailyhealthandbeauty.com/api/2026-07/graphql.json',
  token: '69f0eb672fa246b694186c2d6865010b',

  /*
   * Customer Account API
   *
   * This section contains the public application configuration used by the
   * Support page and future customer-facing experiences that need authenticated
   * customer data such as orders and fulfillment details.
   *
   * The Support page is the shared authentication callback and return point.
   * Future pages can begin authentication and return through Support while
   * preserving the page where the customer started.
   */
  customerAccount: {
    clientId: '420a93a1-78b3-4bac-9b87-622e647512da',

    authorizationEndpoint:
      'https://myaccount.dailyhealthandbeauty.com/authentication/oauth/authorize',

    tokenEndpoint:
      'https://myaccount.dailyhealthandbeauty.com/authentication/oauth/token',

    logoutEndpoint:
      'https://myaccount.dailyhealthandbeauty.com/authentication/logout',

    /* Approved Customer Account application URLs */
    callbackUri: 'https://dailyhealthandbeauty.com/pages/support',
    javascriptOrigin: 'https://dailyhealthandbeauty.com',
    logoutUri: 'https://dailyhealthandbeauty.com/pages/support',

    /* Current API version target */
    apiVersion: '2026-07'
  }
};
